import { ChangeDetectionStrategy, Component, OnInit, computed, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { AuthenticationService } from '@data/apis';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './auth.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly authenticationService = inject(AuthenticationService);

  currentPath = signal(this.router.url);

  imagen = signal<{ loginUrl: string; crearCuentaUrl: string; recuperarClaveUrl: string; tokenUrl: string } | null>(
    null
  );
  currentImage = computed(() => {
    const currentPath = this.currentPath().split('?')[0];
    const imagen = this.imagen();

    if (currentPath === '/login') {
      return imagen?.loginUrl;
    }

    if (currentPath === '/registro') {
      return imagen?.crearCuentaUrl;
    }

    if (currentPath === '/recuperar-clave') {
      return imagen?.recuperarClaveUrl;
    }

    if (currentPath === '/cambiar-clave' || currentPath === '/activar' || currentPath === '/activar-paciente') {
      return imagen?.tokenUrl;
    }

    return '';
  });

  ngOnInit() {
    this.checkRoute();
    //this.getBackground();
  }

  /*  getBackground() {
    this.authenticationService
      .initImagen()
      .pipe(untilDestroyed(this))
      .subscribe(response => this.imagen.set(response));
  } */

  checkRoute() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        untilDestroyed(this)
      )
      .subscribe(event => {
        // console.log(event);
        this.currentPath.set((event as NavigationEnd).url);
      });
  }
}
